import React from "react";
import Icon from "./Icon";
import AddressSearch from "./AddressSearch";
import { OMNI_LOGIN_URL, PRG_SELECTOR_URL, SURVSOLAR_URL } from "../lib/config";

function AccountChip({ auth }) {
  if (auth.status === "loading") return null;
  if (auth.status === "paid") {
    const piano = auth.plans?.omnisurv ? "OmniSurv" : "SurvMaps";
    return (
      <a className="sm-account is-paid" href={OMNI_LOGIN_URL} target="_blank" rel="noopener noreferrer"
         title={`Account OmniSurv con abbonamento ${piano}`}>
        <Icon name="check" size={14} /> {auth.email || "Account OmniSurv"} · {piano}
      </a>
    );
  }
  if (auth.status === "free") {
    return (
      <a className="sm-account" href={OMNI_LOGIN_URL} target="_blank" rel="noopener noreferrer"
         title="Account senza abbonamento attivo">
        <Icon name="user" size={14} /> {auth.email || "Account OmniSurv"}
      </a>
    );
  }
  return (
    <a className="sm-account" href={OMNI_LOGIN_URL} target="_blank" rel="noopener noreferrer">
      <Icon name="user" size={14} /> Accedi a OmniSurv
    </a>
  );
}

export default function Header({ city, onChangeCity, map, searchBounds, auth, showLinks }) {
  return (
    <header className="sm-header">
      <span className="sm-brand">SURVMAPS</span>
      <span className="sm-header-sep" />
      <button type="button" className="sm-city-btn" onClick={onChangeCity}>
        <span className="sm-label" style={{ letterSpacing: "var(--ls-wide)" }}>Comune</span>
        <span className="sm-city-name">{city ? city.name : "Scegli"}</span>
        <Icon name="chevron-down" size={14} />
      </button>
      {city && <AddressSearch key={city.key} map={map} bounds={searchBounds} />}
      <div className="sm-header-spacer" />
      {showLinks && (
        <nav className="sm-header-links" aria-label="Altri strumenti">
          <a className="sm-btn sm-btn--ghost sm-btn--sm" href={PRG_SELECTOR_URL} target="_blank" rel="noopener noreferrer">
            PRG Selector <Icon name="external-link" size={12} />
          </a>
          <a className="sm-btn sm-btn--ghost sm-btn--sm" href={SURVSOLAR_URL} target="_blank" rel="noopener noreferrer">
            SurvSolar <Icon name="external-link" size={12} />
          </a>
        </nav>
      )}
      <AccountChip auth={auth} />
    </header>
  );
}
